import TxpStyle from 'txp-data/lib/schema/viewSchema/TxpStyle';
import ButtonColors from '../../../lib/store/viewSchema/ButtonColors';

/**
 * Returns a string form of a color from the specified TxpStyle if it exists
 * @param specificColor the button colors
 * @param txpStyle Txp Style from which the colors are pulled from
 */

export default function getColor(specificColor: ButtonColors, txpStyle: TxpStyle): string {
    let color: string = null;

    switch (specificColor) {
        case ButtonColors.Primary:
            color = txpStyle.primaryColor ? txpStyle.primaryColor : null;
            break;

        case ButtonColors.Darker:
            color = txpStyle.darkerColor ? txpStyle.darkerColor : null;
            break;

        case ButtonColors.Dark:
            color = txpStyle.darkColor ? txpStyle.darkColor : null;
            break;

        case ButtonColors.Lighter:
            color = txpStyle.lighterColor ? txpStyle.lighterColor : null;
            break;

        case ButtonColors.Light:
            color = txpStyle.lightColor ? txpStyle.lightColor : null;
            break;
        default:
            color = null;
    }

    return color;
}
